import { useEffect, useState } from 'react'
import { supabase } from '../../../lib/supabase'
import AdminLayout from '../components/AdminLayout'
import ChapterCard from './components/ChapterCard'
import ChapterForm from './components/ChapterForm'
import LoadingSpinner from '../../../components/LoadingSpinner'

export default function AdminChapters() {
  const [chapters, setChapters] = useState([])
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)

  const fetchChapters = async () => {
    const { data } = await supabase
      .from('chapters')
      .select('*, supporters(count)')
      .eq('club_id', 'a0000000-0000-0000-0000-000000000001')
      .order('created_at', { ascending: true })
    if (data) setChapters(data)
    setLoading(false)
  }

  useEffect(() => { fetchChapters() }, [])

  return (
    <AdminLayout>
      <div className="mb-6 lg:mb-8 flex justify-between items-center gap-4">
        <div>
          <h1 className="text-2xl lg:text-4xl font-black uppercase tracking-tight mb-2 text-gray-900 dark:text-white">
            Chapters
          </h1>
          <p className="text-gray-500 text-sm">{chapters.length} active chapters</p>
        </div>
        <button
          onClick={() => setShowForm(true)}
          className="bg-green-600 hover:bg-green-700 text-white px-4 sm:px-6 py-3 font-bold uppercase tracking-widest text-xs sm:text-sm transition-colors whitespace-nowrap"
        >
          Add Chapter
        </button>
      </div>

      {loading ? (
        <LoadingSpinner fullScreen message="Loading chapters..." />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
          {chapters.map((chapter) => (
            <ChapterCard key={chapter.id} chapter={chapter} onRefresh={fetchChapters} />
          ))}
        </div>
      )}

      {showForm && (
        <ChapterForm onClose={() => setShowForm(false)} onRefresh={fetchChapters} />
      )}
    </AdminLayout>
  )
}